(() => {
  angular
    .module('app.core')
    .factory('CustomSegmentsService', CustomSegmentsService);

  CustomSegmentsService.$inject = ['$resource'];

  function CustomSegmentsService($resource) {
    const customSegmentsResource = $resource('/customsegments/:action', {}, {
      'getcustomers': {
        method: 'GET',
        params: {
          action: 'getcustomers'
        }
      },
      'update': {
        method: 'POST',
        params: {
          action: 'update'
        }
      },
      'save': {
        method: 'POST',
        params: {
          action: 'save'
        }
      },
      'delete': {
        method: 'POST',
        params: {
          action: 'delete'
        }
      },
      'isAvailable': {
        method: 'POST',
        params: {
          action: 'isAvailable'
        }
      }
    });

    customSegmentsResource.getPaginatedCustomSegments = function (scope, pageId, itemsPerPage, sortPredicate, isSortOrderAscending) {
      return customSegmentsResource.get({
        action: 'query',
        scope: scope,
        pageId: pageId,
        itemsPerPage: itemsPerPage,
        sortPredicate: sortPredicate,
        sortOrder: isSortOrderAscending ? 'asc' : 'desc'
      }).$promise;
    };

    return customSegmentsResource;
  }
})();
